t = require('app/scripts/views/internal/teacup-with-helpers')('power_ups_detail_navbar')

module.exports = ->
  t.a { class: 'nav-item js-toolbar-select ' + t.mustacheBlock('screenshots', (-> 'active')), href: '#', name: 'screenshots' }, ->
    t.format 'screenshots'
  t.a { class: 'nav-item js-toolbar-select ' + t.mustacheBlock('settings', (-> 'active')), href: '#', name: 'settings' }, ->
    t.format 'settings'
